import React from "react";
import "./css/StayConnectedSocialIcons.css";
import { Link } from "react-router-dom";

export default function StayConnectedSocialIcons() {
  return (
    <div  style={{padding: "1rem 0 8rem 0"}}>
      <div className="customcontainer">

        <div className="newsletter-cta">

          {/* LEFT SIDE */}
          <div className="cta-left">
            <h2>
           Ignite change beyond <span>boundaries</span> ...
            </h2>
          </div>
          <div className="cta-right" >
            <Link className="cta-button" to={"/connect"}>
             Let's Connect  →
            </Link>
          </div>

        </div>

      </div>
    </div>
  );
}